module.exports = __webpack_public_path__ + "media/images/about/building-6c140ed7651fb32e708446a319c9e610.png";